"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("h1", {
    staticClass: "page-title"
  }, [_vm._v("\n      Marcações\n    ")]), _vm._v(" "), _c("records-table", {
    attrs: {
      data: _vm.data,
      loading: _vm.isLoading
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoading = $event;
      },
      action: _vm.handleAction
    }
  }), _vm._v(" "), _c("b-pagination", {
    staticClass: "mt-4",
    attrs: {
      total: _vm.meta.total,
      current: _vm.meta.currentPage,
      "per-page": _vm.meta.perPage,
      order: "is-centered",
      size: "is-small"
    },
    on: {
      "update:current": function updateCurrent($event) {
        return _vm.$set(_vm.meta, "currentPage", $event);
      },
      change: _vm.handlePageChange
    }
  }), _vm._v(" "), _c("AttendanceDetailsModal", {
    attrs: {
      data: _vm.selectedAttendance,
      "is-modal-active": _vm.isDetailsModalActive
    },
    on: {
      onClose: function onClose($event) {
        _vm.isDetailsModalActive = false;
      }
    }
  }), _vm._v(" "), _c("EditAttendanceModal", {
    attrs: {
      data: _vm.selectedAttendance,
      "is-modal-active": _vm.isEditModalActive
    },
    on: {
      onCreate: _vm.fetchAttendances,
      onClose: function onClose($event) {
        _vm.isEditModalActive = false;
      }
    }
  })], 1)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;